import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';

export namespace QuantitySingleErrorProvider {
  export class ErrorMessage extends BaseAsyncValue<string> {
    getValue(): Observable<string> {
      const translate: TranslateService = this.injector.get(TranslateService);
      const quantityFormControl = this.form.get(SpecFieldNames.QUANTITY);
      const statusChanges$ = quantityFormControl.statusChanges.pipe(
        map((status) => {
          if (quantityFormControl.invalid && quantityFormControl.hasError('min')) {
            const minVolumeQuantity = quantityFormControl.errors.min.min;
            const unit = quantityFormControl.errors.min.unit;

            const message = translate.instant('views.order.single_catalogs.quantity.error.minimum', {
              quantity: minVolumeQuantity,
              unit: unit,
            });
            return message;
          }
          return null;
        }),
        takeUntil(this.ngDestroy),
      );
      return statusChanges$;
    }
  }
}
